import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { BadgeDollarSign, CircleDollarSign } from 'lucide-react';
import { useAuth } from '../../context';
import { apiGetSales } from '../../api';
import AppShell from '../AppShell/AppShell';
import { PageHeader, StatusBadge } from '../ui/WorkspaceUI';

const STATUS_LABEL = {
  complete: 'Complete',
  in_progress: 'In Progress',
  couldnt_complete: "Couldn't Complete",
  waiting_for_payment: 'Waiting for Payment',
};
export default function SalesPage() {
  const { jwtToken } = useAuth();
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      setSales(await apiGetSales(jwtToken));
      setError('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [jwtToken]);

  useEffect(() => { load(); }, [load]);

  const total = useMemo(() => sales.reduce((sum, sale) => sum + (Number(sale.amountUsd) || 0), 0), [sales]);
  return (
    <AppShell>
        <div className="workspace-page">
          <PageHeader title="Sales" description="Read-only pipeline visibility" breadcrumbs={[{ label: 'Workspace', to: '/portal' }, { label: 'Sales' }]} />
          <div className="sales-summary-grid">
            <div className="card sales-summary-card"><BadgeDollarSign size={19} /><span>Total sales</span><strong>{sales.length}</strong></div>
            <div className="card sales-summary-card"><CircleDollarSign size={19} /><span>Pipeline value</span><strong>${total.toLocaleString()}</strong></div>
          </div>
          {error ? <div className="popup-error">{error}</div> : loading ? <div className="empty"><span className="spinner" /></div> : (
            <div className="table-wrap sales-readonly-table">
              <table>
                <thead><tr><th>Date</th><th>Client</th><th>Email / Phone</th><th>Services</th><th>Amount</th><th>Status</th></tr></thead>
                <tbody>
                  {sales.length === 0 && <tr><td colSpan={6} className="empty">No sales records</td></tr>}
                  {sales.map((sale) => (
                    <tr key={sale._id}>
                      <td>{new Date(sale.date).toLocaleDateString()}</td>
                      <td>{sale.clientName}</td>
                      <td className="text-muted text-sm">{sale.email}{sale.email && sale.phone ? <br /> : null}{sale.phone}</td>
                      <td>{sale.services}</td>
                      <td>${Number(sale.amountUsd || 0).toLocaleString()}</td>
                      <td><StatusBadge status={sale.status} label={STATUS_LABEL[sale.status]} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
    </AppShell>
  );
}
